// extracted by mini-css-extract-plugin
export default {"card":"CategoryBars_card__-uqWA","title":"CategoryBars_title__o+HKG","note":"CategoryBars_note__FhvbU"};